import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetListsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetListsQuery = {
  __typename?: 'Query';
  lists: {
    __typename?: 'ListConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'ListEdge';
      cursor: string;
      node: {
        __typename?: 'List';
        id: any;
        name: string;
        description?: string | null;
        status: Types.ListStatus;
        isSystem: boolean;
        itemType: Types.ListItemType;
        createdAt: any;
        updatedAt: any;
        items: { __typename?: 'ListItemConnection'; totalCount: number };
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetListsDocument = gql`
  query GetLists($after: String, $before: String, $first: Int, $last: Int) {
    lists(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        cursor
        node {
          id
          name
          description
          status
          isSystem
          itemType
          createdAt
          updatedAt
          items {
            totalCount
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetListsQuery__
 *
 * To run a query within a React component, call `useGetListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetListsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetListsQuery, GetListsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetListsQuery, GetListsQueryVariables>(
    GetListsDocument,
    options,
  );
}
export function useGetListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListsQuery,
    GetListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetListsQuery, GetListsQueryVariables>(
    GetListsDocument,
    options,
  );
}
export function useGetListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetListsQuery, GetListsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetListsQuery, GetListsQueryVariables>(
    GetListsDocument,
    options,
  );
}
export type GetListsQueryHookResult = ReturnType<typeof useGetListsQuery>;
export type GetListsLazyQueryHookResult = ReturnType<
  typeof useGetListsLazyQuery
>;
export type GetListsSuspenseQueryHookResult = ReturnType<
  typeof useGetListsSuspenseQuery
>;
export type GetListsQueryResult = Apollo.QueryResult<
  GetListsQuery,
  GetListsQueryVariables
>;
